import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchOrgScheduleSearchArgs,
  FetchScheduleSearchArgs,
} from '../api/types/scheduleSearch.types';

import {
  fetchOrgScheduleSearch,
  fetchScheduleSearch,
} from '../api/scheduleSearch.api';

export const scheduleSearchQueryKeys = createQueryKeys('scheduleSearch', {
  fetchOrgScheduleSearch: (args: FetchOrgScheduleSearchArgs) => ({
    queryFn: () => fetchOrgScheduleSearch(args),
    queryKey: [
      args.organizationId,
      args.q,
      args.kinds,
      args.clientId,
      args.trainerId,
      args.page,
      args.limit,
    ],
  }),
  fetchScheduleSearch: (args: FetchScheduleSearchArgs) => ({
    queryFn: () => fetchScheduleSearch(args),
    queryKey: [args.q, args.kinds, args.page, args.limit],
  }),
});
